// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { Fill } from "./fill";

/**
 * A complete LN2 message. The engine clones `msg` and writes only the parts
 * that `fill` names. Two templates are equal when their packed bytes are.
 */
export class Template implements flatbuffers.IUnpackableObject<TemplateT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Template {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTemplate(bb: flatbuffers.ByteBuffer, obj?: Template): Template {
    return (obj || new Template()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTemplate(bb: flatbuffers.ByteBuffer, obj?: Template): Template {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Template()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  msg(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fill(): Fill {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Fill.Active;
  }

  static startTemplate(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMsg(builder: flatbuffers.Builder, msgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, msgOffset, 0);
  }

  static addFill(builder: flatbuffers.Builder, fill: Fill) {
    builder.addFieldInt8(1, fill, Fill.Active);
  }

  static endTemplate(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // msg
    return offset;
  }

  static createTemplate(
    builder: flatbuffers.Builder,
    msgOffset: flatbuffers.Offset,
    fill: Fill,
  ): flatbuffers.Offset {
    Template.startTemplate(builder);
    Template.addMsg(builder, msgOffset);
    Template.addFill(builder, fill);
    return Template.endTemplate(builder);
  }

  unpack(): TemplateT {
    return new TemplateT(this.msg() !== null ? this.msg()!.unpack() : null, this.fill());
  }

  unpackTo(_o: TemplateT): void {
    _o.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    _o.fill = this.fill();
  }

  unpackFields(...fields: string[]): TemplateT {
    const t = new TemplateT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("msg")) {
      t.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    }
    if (fieldSet.has("fill")) {
      t.fill = this.fill();
    }
    return t;
  }
}

export class TemplateT implements flatbuffers.IGeneratedObject {
  constructor(
    public msg: ValuedMessageT | null = null,
    public fill: Fill = Fill.Active,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.msg === null || this.msg === undefined) {
      throw new Error('Required field "msg" is not set');
    }
    const msg = this.msg !== null ? this.msg!.pack(builder) : 0;

    return Template.createTemplate(builder, msg, this.fill);
  }

  clone(): TemplateT {
    const obj = new TemplateT();
    obj.msg = this.msg !== null ? this.msg!.clone() : null;
    obj.fill = this.fill;
    return obj;
  }

  equals(other: TemplateT): boolean {
    if (this.msg !== null && other.msg !== null) {
      if (!this.msg!.equals(other.msg!)) return false;
    } else if (this.msg !== other.msg) return false;
    if (this.fill !== other.fill) return false;
    return true;
  }
}

export function verifyTemplate(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "msg");
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}
